import React from 'react'

const arrayItemStyles = (index: number): React.CSSProperties => ({
  padding: '8px 10px',
  marginBottom: '6px',
  borderRadius: '6px',
  background: index % 2 === 0 ? '#f8f9fa' : '#ffffff',
  border: '1px solid #e9ecef',
})

interface RenderObjectProps {
  data: unknown
  depth?: number
  allowedKeys?: string[]
}

const RenderObject: React.FC<RenderObjectProps> = ({ data, depth = 0, allowedKeys }) => {
  if (typeof data === 'object' && data !== null) {
    if (Array.isArray(data)) {
      return (
        <div style={{ marginTop: depth > 0 ? '4px' : 0 }}>
          {data.map((item, index) => (
            <div key={index} style={arrayItemStyles(index)}>
              <RenderObject data={item} depth={depth + 1} />
            </div>
          ))}
        </div>
      )
    }

    const entries = Object.entries(data as Record<string, unknown>)
    const filteredEntries =
      allowedKeys && depth === 0 ? entries.filter(([key]) => allowedKeys.includes(key)) : entries

    return (
      <div className={depth > 0 ? 'kyc-render__object' : undefined}>
        {filteredEntries.map(([key, value]) => (
          <div key={key} className='kyc-render__row'>
            {}
            <span className='kyc-render__key'>{key}</span>
            <span className='kyc-render__value'>
              <RenderObject data={value} depth={depth + 1} />
            </span>
          </div>
        ))}
      </div>
    )
  }

  const primitive = data as string | number | boolean | null | undefined
  return (
    <span className='kyc-render__value'>
      {primitive !== null && primitive !== undefined && primitive !== '' ? (
        String(primitive)
      ) : (
        <span style={{ color: '#adb5bd', fontStyle: 'italic' }}>N/A</span>
      )}
    </span>
  )
}

export default RenderObject
